import React from 'react';
import AircraftSection from './aircraft/AircraftSection';

const Aircraft = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Aircraft</h2>
      <AircraftSection />
    </div>
  );
};

export default Aircraft; 